import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import Nav from "./Nav";

const MobileMenu = ({ MobileHandler }) => {
  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const mobileMenu = document.querySelector(".mobilemenu-popup");
      // Check if the click is outside the mobile menu inner content
      if (
        mobileMenu &&
        mobileMenu.classList.contains("show") &&
        !event.target.closest(".mobilemenu-inner") &&
        !event.target.closest(".mobile-menu-btn")
      ) {
        MobileHandler();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [MobileHandler]);

  return (
    <>
      <style>
        {`
          /* Mobile Menu Styles - Improved Design */
          .mobilemenu-popup {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.6);
            z-index: 9999;
            visibility: hidden;
            opacity: 0;
            transition: all 0.3s ease;
            display: flex;
            justify-content: flex-start;
          }

          .mobilemenu-popup.show {
            visibility: visible;
            opacity: 1;
          }

          .mobilemenu-inner {
            width: 280px;
            max-width: 85%;
            height: 100%;
            background-color: #fff;
            overflow-y: auto;
            transform: translateX(-100%);
            transition: transform 0.3s ease;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
          }

          .mobilemenu-popup.show .mobilemenu-inner {
            transform: translateX(0);
          }

          .mobilemenu-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px 20px;
            border-bottom: 1px solid #e9e9e9;
            background-color: #f8f9fa;
          }
          
          .mobilemenu-header .site-logo {
            max-width: 120px;
          }

          .mobile-menu-close {
            background: none;
            border: none;
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            color: #6600cc;
            cursor: pointer;
            transition: all 0.2s ease;
            padding: 0;
          }
          
          .mobile-menu-close:hover {
            background-color: rgba(102, 0, 204, 0.1);
          }
          
          .mobile-menu-close svg {
            font-size: 18px;
          }

          .mobilemenu-body {
            padding: 15px 5px;
          }

          /* Navigation Menu Styles */
          .mobile-nav {
            margin-bottom: 20px;
          }
          
          .mobile-nav ul {
            list-style: none;
            padding: 0;
            margin: 0;
          }
          
          .mobile-nav ul li {
            border-bottom: 1px solid #eee;
          }
          
          .mobile-nav ul li:last-child {
            border-bottom: none;
          }
          
          .mobile-nav ul li a {
            display: block;
            padding: 12px 0;
            color: #333;
            text-decoration: none;
            font-size: 15px;
            font-weight: 500;
            transition: all 0.2s ease;
          }
          
          .mobile-nav ul li a:hover,
          .mobile-nav ul li a:active {
            color: #6600cc;
          }

          /* Login section */
          .mobile-login-options {
            background-color: #f8f9fa;
            border-radius: 8px;
            padding: 15px;
            margin-top: 10px;
          }

          .mobile-login-options h6 {
            font-size: 15px;
            font-weight: 600;
            color: #333;
            margin-bottom: 15px;
            padding-bottom: 8px;
            border-bottom: 1px solid #e9e9e9;
          }

          .mobile-login-links a {
            display: flex;
            align-items: center;
            padding: 10px 0;
            color: #6600cc;
            text-decoration: none;
            font-size: 14px;
            transition: all 0.2s ease;
          }
          
          .mobile-login-links a:not(:last-child) {
            border-bottom: 1px solid #eee;
          }

          .mobile-login-links a:hover {
            color: #5500aa;
          }

          .mobile-login-links a svg {
            margin-right: 10px;
            min-width: 16px;
          }
          
          /* Call to Action Section */
          .mobile-cta {
            margin-top: 20px;
            padding-top: 20px;
            border-top: 1px solid #e9e9e9;
          }
          
          .mobile-cta .btn {
            display: block;
            text-align: center;
            padding: 7px;
            border-radius: 6px;
            font-weight: 600;
            margin-bottom: 10px;
            text-decoration: none;
            transition: all 0.3s ease;
          }
          
          .mobile-cta .btn-primary {
            background-color: #6600cc;
            color: white;
            border: none;
          }
          
          .mobile-cta .btn-primary:hover {
            background-color: #5500aa;
          }
          
          .mobile-cta .btn-outline {
            border: 1px solid #6600cc;
            color: #6600cc;
            background-color: transparent;
          }
          
          .mobile-cta .btn-outline:hover {
            background-color: rgba(102, 0, 204, 0.1);
          }

          /* Hide mobile menu on larger screens */
          @media (min-width: 992px) {
            .mobilemenu-popup {
              display: none !important;
            }
          }
          
          /* Mobile specific styles */
          @media (max-width: 375px) {
            .mobilemenu-inner {
              width: 260px;
            }
            
            .mobile-login-links a {
              font-size: 13px;
            }
          }
        `}
      </style>
      <div className="mobilemenu-popup">
        <div className="mobilemenu-inner">
          <div className="mobilemenu-header">
            <div className="site-logo">
              <a href="/">
                <img src="/images/logo.png" alt="Logo" height="35" />
              </a>
            </div>
            <button className="mobile-menu-close" onClick={MobileHandler}>
              <FaTimes />
            </button>
          </div>
          <div className="mobilemenu-body">
            <div className="mobile-nav">
              <Nav />
            </div>

            <div className="mobile-login-options">
              <h6>Login Options</h6>
              <div className="mobile-login-links">
                <Link to={process.env.PUBLIC_URL + "/login"}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    viewBox="0 0 16 16">
                    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                    <path
                      fillRule="evenodd"
                      d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                    />
                  </svg>
                  For Individual
                </Link>
                {/* <Link to={process.env.PUBLIC_URL + "/recruiterslogin"}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                  </svg>
                  For Recruiters
                </Link>
                <Link to={process.env.PUBLIC_URL + "/organizationlogin"}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8.5 5.5a.5.5 0 0 0-1 0v.634l-.622-.312a.5.5 0 1 0-.447.894L7.5 6.945v.11l-1.69.845a.5.5 0 0 0 .447.894l2.17-1.085a.5.5 0 0 0 .276-.447V5.5z" />
                    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                  </svg>
                  For Organization
                </Link> */}
              </div>
            </div>

            <div className="mobile-cta">
              {/* <Link to={process.env.PUBLIC_URL + "/feedback"} className="btn btn-primary">
                MVP Feedback
              </Link> */}
              <Link
                to={process.env.PUBLIC_URL + "/subscription"}
                className="btn btn-outline">
                Sign Up
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileMenu;
